/**
 * 搜索热点
 */
"use strict";
angular.module("searchChannelHotSpotsModule", [
    "shCommonListModule", //搜索热点通用列表组件
]).
controller("searchChannelHotSpotsCtrl", ["$scope", "trsHttpService", function($scope, trsHttpService) {
    initStatus();
    initData();

    function initStatus() {
        $scope.data = {
            allSourceData: []
        }
    }

    function initData() {
        getMedias();
    }

    /**
     * [getList description]
     * @param {[type]} [varname] [description] 产品信息
     * @return {[type]} [description]
     */
    $scope.getList = function(item) {
        item.activeName = item.tabnames[0].displayTabName; // tabname哪个被激活，默认第一个； 分页回调时用到
        item.tabnames.forEach(function(item, index) {
            item.param = {
                page_no: '0',
                page_size: '10',
                site_name: item.searchSiteName,
                channel: item.channel,
                tabname: item.searchTabName
            }
            requestShList(item);
        });
    }

    /**
     * [getMedias description] 媒体列表
     * @return {[type]}      [description]
     */
    function getMedias() {
        var params = {
            typeid: "widget",
            serviceid: "channelHotSearchHotpointMgr",
            modelid: "getMedias"
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
            if (data.MAPRESULT && data.MAPRESULT.STATUS == 'success') {
                $scope.data.allSourceData = data.MAPRESULT.CONTENT;

                // 默认展开分类
                $scope.data.allSourceData.forEach(function(item, index) {
                    $scope.open(item.value);
                })
            }
        });
    }

    /**
     * [requestShList description] 请求热点数据
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    function requestShList(item) {
        var params = {
            typeid: "widget",
            serviceid: "channelHotSearchHotpointMgr",
            modelid: "getArticles"
        };
        Object.assign(params, item.param);
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.MAPRESULT.STATUS && data.MAPRESULT.STATUS == 'success') {
                item.articlesData = data.MAPRESULT.CONTENT.PAGEITEMS;
                item.param.allPages = data.MAPRESULT.CONTENT.TOTALPAGECOUNT;
                item.param.page_no = data.MAPRESULT.CONTENT.PAGEINDEX;
            }
        });
    }
    /**
     * [changePage description]计算是否展开或者收起分类
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.calcIsOpen = function(item) {
        if (!item) {return false;}
        var flag = false;
        if (item) {
            for (let i = item.length - 1; i >= 0; i--) {
                if (item[i].isOpen) {
                    flag = true;
                    return flag;
                }
            }
        }
        return flag;
    }


    /**
     * [openClassify description]展开分类
     * @return {[type]} [description]
     */
    $scope.open = function(dataObj) {
        if (!dataObj) {return;}
        var isOpen = false;
        dataObj.forEach(function(item) {
            if (item.isOpen) {
                isOpen = true;
            }
        });
        if (isOpen) {
            dataObj.forEach(function(item) {
                item.isOpen = false;
            });
        } else {
            dataObj.forEach(function(item) {
                item.isOpen = true;
                $scope.getList(item);
            });
        }
    }

    /**
     * [changePage description]分页
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.changePage = function(item) {
        item.tabnames.forEach(function(itemchild, index) {
            if (itemchild.displayTabName == item.activeName) {
                itemchild.param = {
                    page_no: itemchild.param.page_no,
                    page_size: '10',
                    site_name: itemchild.searchSiteName,
                    channel: itemchild.channel,
                    tabname: itemchild.searchTabName
                }
                requestShList(itemchild);
            }
        });
        // requestShList(item)
    }

}]);